import { render, staticRenderFns } from "./TitleDescription.vue?vue&type=template&id=3db8deb3&"
import script from "./TitleDescription.vue?vue&type=script&lang=ts&"
export * from "./TitleDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports